import { render, staticRenderFns } from "./SelectImagesModal.vue?vue&type=template&id=5bea8fde&scoped=true"
import script from "./SelectImagesModal.vue?vue&type=script&lang=ts"
export * from "./SelectImagesModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectImagesModal.vue?vue&type=style&index=0&id=5bea8fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea8fde",
  null
  
)

export default component.exports